export default __webpack_public_path__ + "static/media/coinbase.c7458bce.png";